import React from "react";
import { getContentPageProps } from "../logic/contentLogic";

const Article = React.lazy(() => import("../components/Article"));

export const renderArticleSectionContent = (content, props = {}) => {
  return <Article key={content.id} {...getContentPageProps(content)} />;
};
